import { useEffect, useState } from "react";
//API
import { axiosWithAuth } from "../../../api/axiosConfig";
import { urlGetOpetativoActivosSaf } from "../../../api/URLs/operativos";
//Components
import TableMain from "../../../components/Tools/Tables/TableMain/TableMain";
import CustomBtn from "../../../components/Tools/Basics/CustomBtn";
import Divider from "../../../components/Tools/Basics/Divider";
import ModalPlain from "../../../components/Modals/ModalPlain";
//Modal
import { useModal } from "../../../hooks/useModal";
import ModalAlert from "../../../components/Modals/ModalAlert";
import DetalleOperativosSAF from "./DetalleOperativosSAF";

const TableOperativosActivosSAF = () => {
  //useModal
  const { handleError, showModal, modalType, msjModal, handleClose } =
    useModal();
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [showModalPlain, setShowModalPlain] = useState(false);
  const [codope, setCodope] = useState(null);

  //handles
  const handleCloseModalPlain = () => setShowModalPlain(false);
  const handleOpenModalPlain = (c) => {
    setCodope(c.codope);
    setShowModalPlain(true);
  };

  const actionButton = (c) => {
    return (
      <CustomBtn
        type={"link_table"}
        text={"Ver Detalle"}
        onClick={() => handleOpenModalPlain(c)}
      />
    );
  };

  //Get Data
  const getData = async () => {
    try {
      setLoading(true);
      const api_response = await axiosWithAuth.get(urlGetOpetativoActivosSaf);
      setData(api_response.data);
    } catch (error) {
      const auxError = error.response.data.msj
        ? error.response.data.msj
        : "Error del servidor";
      handleError(auxError);
    } finally {
      setLoading(false);
    }
  };
  //Clase de fila
  //   const rowClass = (data) => {
  //     return {
  //       "bg-success bg-opacity-50 text-white fw-bold":
  //         data.ctrlUltimaPosicion === 6,
  //     };
  //   };
  //Columns
  const columns = [
    { field: "codope", header: "CodOpe." },
    { field: "nomope", header: "Nombre Operativo" },
    { header: "Acciones", body: actionButton },
  ];

  useEffect(() => {
    getData();
  }, []);
  return (
    <div className="custom-container">
      <h2>
        <b>Operativos Activos Buques SAF</b>
      </h2>
      <Divider />
      <TableMain
        data={data}
        columns={columns}
        loading={loading}
        // rowClass={rowClass}
        noHeader
      />
      <ModalAlert
        show={showModal}
        type={modalType}
        msj={msjModal}
        handleClose={handleClose}
      />
      {showModalPlain ? (
        <ModalPlain show={true} handleClose={handleCloseModalPlain} size={"lg"}>
          <DetalleOperativosSAF codope={codope} />
        </ModalPlain>
      ) : null}
    </div>
  );
};

export default TableOperativosActivosSAF;
